import React from 'react'
import { useParams } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { withAuthenticatedRoute } from 'lib/auth'
import { ThemeProvider } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import EmptyPageState from 'components/empty-page-state'
import PartyPopperIcon from 'components/icons/party-popper-icon'
import themes, { extendTheme } from 'themes'
import PGALogo from 'images/pga-logo-navy.png'
import useDetailStyles from '../../detail-styles'
import LessonPlanDetailView from '../../components/lesson-plan-detail-view'
import useCoachActivityHit from '../../hooks/use-coach-activity-hit'
import useCoachActivityHits from '../../hooks/use-coach-activity-hits'

const isIntercomOverride = !!window.location.search.match(/intercomOverride/i)

const SinglePlansPublicPage = () => {
  const { id } = useParams()
  const classes = useDetailStyles()
  const { hit: planHit, isLoading: isPlanLoading } = useCoachActivityHit(id)
  const {
    hits: activityHits,
    isLoading: areActivitiesLoading,
  } = useCoachActivityHits(planHit)
  const isLoading = isPlanLoading || areActivitiesLoading

  return (
    <ThemeProvider
      theme={extendTheme({
        ...themes.pgaCoach,
        ...(isIntercomOverride ? themes.intercom : {}),
      })}
    >
      <Helmet>
        <title>PGA | Activity plans</title>
        <meta name="description" content="PGA | Activity plans" />
        <link rel="icon" href="/pga-coach-favicon.ico" />
      </Helmet>
      <Container maxWidth="md">
        <Grid container spacing={2} style={{ margin: '16px 0' }}>
          <img src={PGALogo} alt="PGA logo" width={70} />
        </Grid>
      </Container>
      <Box className={classes.page}>
        {isLoading ? null : !planHit ? (
          <Grid item xs={12}>
            <EmptyPageState
              IconComp={() => <PartyPopperIcon />}
              title="No activity plans found."
              removeButton
            />
          </Grid>
        ) : (
          <LessonPlanDetailView
            planHit={planHit}
            activityHits={activityHits}
            inlineActions
          />
        )}
      </Box>
    </ThemeProvider>
  )
}

export default withAuthenticatedRoute(SinglePlansPublicPage)
